import Delete from './delete'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    moneyBoxAmount: campaign.moneybox_amount,
    currency: campaign.currency,
  }
}

export default connect(mapStateToProps)(Delete)
